import {
  createContext,
  useContext,
  useMemo,
  useRef,
  useState,
  type PropsWithChildren,
} from 'react';

interface IProps {
  showCalendarButtonRef: React.RefObject<HTMLButtonElement | null> | null;
  showCalendar: boolean;
  toggleCalendar: () => void;
}

export const ShowCalendarContext = createContext<IProps | undefined>({
  showCalendarButtonRef: null,
  showCalendar: true,
  toggleCalendar: () => {},
});

const ShowCalendarProvider = ({ children }: PropsWithChildren) => {
  const [showCalendar, setShowCalendar] = useState<boolean>(true);
  const showCalendarButtonRef = useRef<HTMLButtonElement | null>(null);

  const toggleCalendar = (): void => setShowCalendar(prev => !prev);

  const value = useMemo(
    () => ({ showCalendarButtonRef, showCalendar, toggleCalendar }),
    [showCalendar],
  );

  return <ShowCalendarContext.Provider value={value}>{children}</ShowCalendarContext.Provider>;
};

const useShowCalendarContext = (): IProps => {
  const context = useContext(ShowCalendarContext);

  if (!context) {
    throw new Error('useShowCalendarContext must be used within a ShowCalendarProvider');
  }

  return context;
};

export { ShowCalendarProvider, useShowCalendarContext };
